export const ClanIdToNameAndIconMap: {
	[key: string]: { name: string; bgImage: string; clanIcon: string };
} = {
	'clan-wars-comp-1': {
		name: 'Pi-Rates',
		bgImage: '/clan-wars/bg-brown.webp',
		clanIcon: '/clan-wars/pi-rate.webp'
	},
	'clan-wars-comp-2': {
		name: 'Fibonacci Fighters',
		bgImage: '/clan-wars/bg-blue.webp',
		clanIcon: '/clan-wars/fibonacci-fighters.webp'
	},
	'clan-wars-comp-3': {
		name: 'Calculus Crusaders',
		bgImage: '/clan-wars/bg-pink.webp',
		clanIcon: '/clan-wars/calculus-crusaders.webp'
	},
	'clan-wars-comp-4': {
		name: 'Quadratic Questers',
		bgImage: '/clan-wars/bg-green.webp',
		clanIcon: '/clan-wars/quadratic-questers.webp'
	}
};

export const addressToSendEntryFees = '0xDe0dE090b3ceC6ca1B3B3FB222E79C44ec075127';
